/* eslint-disable sort-keys-fix/sort-keys-fix */
import { Redirect, truthy } from "@quortex/front-common"
import { type DefaultGenerics, Navigate, Outlet, type Route } from "@tanstack/react-location"
import { lazy } from "react"
import { linkRoutes } from "src/App/link/routes"
import urlJoin from "url-join"

// Misc
const Root = lazy(() => import("./Root"))

const Organization = lazy(() =>
  import("@quortex/front-common").then(module => ({ default: module.Organization }))
)

const NotFound = lazy(() =>
  import("@quortex/front-common").then(module => ({ default: module.NotFound }))
)

export const portalTree: Route<DefaultGenerics> = {
  path: "/",
  element: <Root />,
  children: [
    // Old portal routes
    // TODO: move all of them to new portal routes
    {
      path: "organizations/new",
      element: (
        <Redirect
          external
          replace
          to={urlJoin(import.meta.env.REACT_APP_PORTAL_URL, "/organizations/new")}
        />
      )
    },
    {
      path: "organizations/:orgUuid",
      element: (
        <Organization>
          <Outlet />
        </Organization>
      ),
      children: [
        {
          path: "home",
          element: <Navigate to="../link" />
        },
        {
          path: "switch",
          element: <Navigate to="../link" />
        },
        {
          path: "play",
          element: <Navigate to="../link" />
        },
        // App routes
        linkRoutes,
        // Fallback
        { element: <NotFound /> }
      ]
    },

    { element: <NotFound /> }
  ].filter(truthy)
}
